import { cls } from 'reactutils';
import { NetPriceSourceEnum } from 'libs/enums';
import { useState } from 'react';

const NetPriceType = ({ selectNetPriceType, onSelect }) => {
  const [netPriceType, setNetPriceType] = useState(selectNetPriceType || NetPriceSourceEnum.LANGE);
  return (
    <>
      <div className="net-price">
        <div className="pd-l account-label">网价</div>
        <div className="pd-r pd-one-info net-price-wrap">
          <div
            className={cls(
              'product-filter-item net-price-item',
              netPriceType === NetPriceSourceEnum.LANGE && 'active',
            )}
            onClick={() => {
              setNetPriceType(NetPriceSourceEnum.LANGE);
              onSelect(NetPriceSourceEnum.LANGE);
            }}
          >
            兰格网
            <div className="active-icon" />
          </div>
          <div
            className={cls(
              'product-filter-item net-price-item',
              netPriceType === NetPriceSourceEnum.WDGTW && 'active',
            )}
            onClick={() => {
              setNetPriceType(NetPriceSourceEnum.WDGTW);
              onSelect(NetPriceSourceEnum.WDGTW);
            }}
          >
            我的钢铁网
            <div className="active-icon" />
          </div>
        </div>
      </div>
      <style jsx>{`
        .net-price {
          display: flex;
          margin-top: 10px;
        }
        .pd-l {
          width: 50px;
          margin-right: 40px;
          color: #999;
          margin-left: 20px;
          height: 28px;
          line-height: 28px;
          display: inline-block;
          font-size: 12px;
        }
        .pd-one-info {
          position: relative;
          bottom: -4px;
          display: inline-block;
          font-size: 12px;
          width: 600px;
        }
        .product-filter-item {
          display: inline-block;
          padding: 9px 13px 7px 14px;
          font-size: 12px;
          line-height: 12px;
          border: 1px solid #e8e8e8;
          margin-bottom: 10px;
          margin-right: 10px;
          cursor: pointer;
          background-color: #fff;
          border-color: #fff;
          color: #666;
          position: relative;
          width: auto;
          min-width: 84px;
          padding-left: 17px;
          padding-right: 17px;
          text-align: center;
        }
        .product-filter-item.active {
          border-color: var(--rv-primary-color);
        }
        .product-filter-item.active .active-icon {
          display: block;
          position: absolute;
          right: -8px;
          bottom: -8px;
          border: 8px solid transparent;
          border-top: 8px solid var(--rv-primary-color);
          transform: rotate(-45deg);
        }
        .product-filter-item.active .active-icon:after {
          content: "";
          position: absolute;
          left: -2px;
          top: -7px;
          width: 6px;
          height: 3px;
          border-color: transparent transparent #fff #fff;
          border-style: solid;
          border-width: 1px;
        }
        .pd-one-info {
          position: relative;
          bottom: -4px;
        }
      `}</style>
    </>
  );
};
export default NetPriceType;
